import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';

function Scenes() {
    return (
        <>
        <Header/>
        <Footer/>
        </>
    )
}

export default Scenes;